module.exports = __webpack_public_path__ + "img/lit_stake_plsd.b24a7207.png";